import { render, staticRenderFns } from "./RecentInvoice.vue?vue&type=template&id=24130ce0&scoped=true&lang=pug&"
import script from "./RecentInvoice.vue?vue&type=script&lang=js&"
export * from "./RecentInvoice.vue?vue&type=script&lang=js&"
import style0 from "./RecentInvoice.vue?vue&type=style&index=0&id=24130ce0&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24130ce0",
  null
  
)

export default component.exports